import React from 'react';
import '../style/formGroupTextInput.css'
import StrikeThroughList from "./General/strikeThroughList";

const FormGroupPlainText = (props) => {
	const {onLabelClick, leftWrapper} = props;
	return (
		<div className="form-group">
			<div className={leftWrapper ? leftWrapper : "col-xs-3"}>
				<label
					onClick={props.labelAsALink ? onLabelClick : null}
					className={"control-label.text-left formGroup-textInput-label" + (props.labelAsALink ? " formGroup--link-label" : "")}
				>
					{props.Label}
				</label>
			</div>
			<div className={props.InputWrapper}>
				{props.Text}
			</div>
			<div className={props.RightWrapper}>{props.rightData ? props.rightData : null}</div>
			{props.showHistory && (
                <div>
                    <div className={'col-xs-3'}/>
                    <div className={props.InputWrapper}>
                        <StrikeThroughList/>
                    </div>
                </div>
            )}
		</div>
	)
};

export default FormGroupPlainText;
